import React from 'react';
import {
  Application,
  ApplicationStatus,
} from '../../../../../../../entities/Application';
import { RejectApplication } from './RejectApplication';
import { AlertObject } from '../../../../../../../components/Alert';
import { MoveApplication } from './MoveApplication';
import { AddNote } from './AddNote';
import { AddTag } from './AddTag';
import { SendEmail } from './SendEmail';
import { BULK_REVIEW_NAVIGATION_TYPE } from '../../../..';
import { User } from '../../../../../../../entities/User';
import { AccountIntegration } from '../../../../../../../entities/AccountIntegration';

interface PropTypes {
  application: Application;
  preSelectedRejectReasonId: number;
  preSelectedStageId: number;
  isActionsDisabled: boolean;
  currentUser: User;
  emailAccountIntegration: AccountIntegration;
  onNext: (navType: BULK_REVIEW_NAVIGATION_TYPE) => void;
  onClose: () => void;
  onConflict: () => void;
  onNoteAdded: () => void;
  onTagsAdded: () => void;
  setAlert: (alert: AlertObject) => void;
  setPreSelectedRejectReasonId: (id: number) => void;
  setPreSelectedStageId: (id: number) => void;
}

export function ApplicationActions(props: PropTypes) {
  const isRejected = props.application.status === ApplicationStatus.Rejected;
  const isHired = props.application.status === ApplicationStatus.Hired;
  const isTransitionDisabled = props.isActionsDisabled || isRejected || isHired;

  return (
    <div className='d-flex align-items-center pb-2'>
      <AddNote {...props} />
      <AddTag
        application={props.application}
        setAlert={props.setAlert}
        onTagsAdded={props.onTagsAdded}
      />
      <SendEmail
        application={props.application}
        currentUser={props.currentUser}
        emailAccountIntegration={props.emailAccountIntegration}
        setAlert={props.setAlert}
      />
      <div className='vr ms-2 me-3' />
      {props.application.canTransitionApplication && (
        <>
          <RejectApplication
            {...props}
            disabled={isTransitionDisabled}
            onConflict={props.onConflict}
          />
          <MoveApplication
            {...props}
            disabled={isTransitionDisabled}
            onConflict={props.onConflict}
            preSelectedStageId={props.preSelectedStageId}
            setPreSelectedStageId={props.setPreSelectedStageId}
          />
        </>
      )}
    </div>
  );
}
